"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ui_1 = require("@jbrowse/core/ui");
var mui_1 = require("tss-react/mui");
var useStyles = (0, mui_1.makeStyles)()(function (theme) {
  return {
    formElt: {
      margin: theme.spacing(3),
      width: 400
    },
    dialogContent: {
      width: '80em'
    }
  };
});
function SequenceFeatureSettingsDialog(_ref) {
  var handleClose = _ref.handleClose,
    intronBpArg = _ref.intronBp,
    upDownBpArg = _ref.upDownBp;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var _ref2 = (0, react_1.useState)("".concat(intronBpArg)),
    _ref3 = _slicedToArray(_ref2, 2),
    intronBp = _ref3[0],
    setIntronBp = _ref3[1];
  var _ref4 = (0, react_1.useState)("".concat(upDownBpArg)),
    _ref5 = _slicedToArray(_ref4, 2),
    upDownBp = _ref5[0],
    setUpDownBp = _ref5[1];
  var intronBpValid = !Number.isNaN(+intronBp);
  var upDownBpValid = !Number.isNaN(+upDownBp);
  return react_1.default.createElement(ui_1.Dialog, {
    maxWidth: "xl",
    open: true,
    onClose: function onClose() {
      return handleClose();
    },
    title: 'Feature sequence settings'
  }, react_1.default.createElement(material_1.DialogContent, {
    className: classes.dialogContent
  }, react_1.default.createElement(material_1.TextField, {
    label: "Number of intronic bases around splice site to display",
    className: classes.formElt,
    value: intronBp,
    helperText: !intronBpValid ? 'Not a number' : '',
    error: !intronBpValid,
    onChange: function onChange(event) {
      return setIntronBp(event.target.value);
    }
  }), react_1.default.createElement(material_1.TextField, {
    label: "Number of bases up/down stream of feature to display",
    className: classes.formElt,
    value: upDownBp,
    helperText: !upDownBpValid ? 'Not a number' : '',
    error: !upDownBpValid,
    onChange: function onChange(event) {
      return setUpDownBp(event.target.value);
    }
  })), react_1.default.createElement(material_1.DialogActions, null, react_1.default.createElement(material_1.Button, {
    onClick: function onClick() {
      return handleClose({
        upDownBp: +upDownBp,
        intronBp: +intronBp
      });
    },
    disabled: !intronBpValid || !upDownBpValid,
    color: "primary",
    variant: "contained"
  }, "Submit"), react_1.default.createElement(material_1.Button, {
    onClick: function onClick() {
      return handleClose();
    },
    color: "secondary",
    autoFocus: true,
    variant: "contained"
  }, "Cancel")));
}
exports.default = SequenceFeatureSettingsDialog;